module.exports = __webpack_public_path__ + "img/home_400.24b47dd1.webp";